import { getPitchName } from 'bam-node-baseball-savant/utils/pitch-names'
import { RowValue } from 'bam-node-savant-table/table-ts.ts'

// Function (displayFn) to show subway pitch type labels
export default function pitchTypeFn(val?: RowValue) {
    if (!val || typeof val !== 'string') {
        return '<em>Other</em>'
    }
    return `<span
                    style="display: inline-block; margin: 2px 0"
                    class="search-pitch-label search-pitch-label-${val}"
                    title="${getPitchName(val)}"
                >
                    ${val}
                </span>`
}
